import { createAction } from "redux-actions";

export const UPDATE_ITEM = "UPDATE_ITEM";
export const updateItem = createAction(UPDATE_ITEM);

export const UPDATE_ITEM_FAILURE = "UPDATE_ITEM_FAILURE";
export const updateItemFailure = createAction(UPDATE_ITEM_FAILURE);

export const UPDATE_ITEM_REQUESTED = "UPDATE_ITEM_REQUESTED";
export const updateItemRequested = createAction(UPDATE_ITEM_REQUESTED);

export const UPDATE_ITEM_SUCCESS = "UPDATE_ITEM_SUCCESS";
export const updateItemSuccess = createAction(UPDATE_ITEM_SUCCESS);
